import * as actionType from "./actions/notificationActions";

const initialState = {
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SELECTED_NOTIFICATION:
      return {
        ...state,
        notificationErrorList: action.payload.notificationErrorList,
        showModal: action.payload.showModal
      };
    default:
      return state;
  }
}
